import React, { Component } from "react";
import { Input } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import 'react-dates/initialize';
import Select from 'react-select';
import { getMessage } from "CONFIG/i18n";
import validator from "validator";

//Stylesheet
import "./UserInviteCustomize.less";
import 'react-dates/lib/css/_datepicker.css';

//ASSETS
import icBar from "ASSETS/Images/ic_bar.svg";

//Actions
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

//Util
import { separatePhoneNumberAndEmails } from "UTILS/Utility";
import { validateMobileNumber } from "UTILS/regexValidations";
import { SMS_MESSAGE_MAX_LENGTH } from "UTILS/Constants";

class UserInviteCustomize extends Component {
  constructor(props) {
    super(props);

    const invitees = this.props.editSessionData ? this.props.editSessionData.invitees.join(',') : "";
    const separators = [",", ";"];
    const arrayOfInvitees = invitees.split(
      new RegExp(separators.join("|"), "g")
    );
    const { arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);

    const emailObj = this.props.editInventDetails ? this.props.editInventDetails.email : null;
    const smsObj = this.props.editInventDetails ? this.props.editInventDetails.phone : null;

    const emailAddresses = this.props.userInventMsgCustomize ? this.props.userInventMsgCustomize.emailAddresses || [] : [];
    const optionEmailFromAddresses = [];

    // If the user is using an ID, the user's own ID will not be added to the email list.
    if (!this.props.userProfileData.isID) {
      optionEmailFromAddresses.push({
        value: this.props.userProfileData.email,
        label: this.props.userProfileData.email,
      })
    }
    emailAddresses.forEach((elem) => {
      optionEmailFromAddresses.push({
        value: elem.email,
        label: elem.email,
      });
    });
    optionEmailFromAddresses.push({
      value: this.props.userInventMsgCustomize.defaultEmailAddress,
      label: this.props.userInventMsgCustomize.defaultEmailAddress,
    });
    let selectedEmailFromAddress = optionEmailFromAddresses[0];
    if (emailObj) {
      selectedEmailFromAddress = optionEmailFromAddresses.find(email => email.label == emailObj.from);
    }

    this.state = {
      emailSubject: emailObj ? emailObj.subject : getMessage("INVITE_USER_TITLE"),
      emailSubjectError: false,
      emailToAddresses: arrayOfEmails.join(","),
      optionEmailFromAddresses,
      selectedEmailFromAddress,
      emailMessage: emailObj ? emailObj.message : getMessage("INVITE_USER", {userName: this.props.userName}),
      emailMessageError: false,
      emailMessageMaxLength: 500,
      smsToNumber: arrayOfPhone.join(","),
      smsMessage: smsObj ? smsObj.message : getMessage("INVITE_USER", {userName: this.props.userName}),
      smsMessageError: false,
      smsMessageMaxLength: this.props.language === 'ja' ? SMS_MESSAGE_MAX_LENGTH.JA : SMS_MESSAGE_MAX_LENGTH.EN,
      isCheckInvite: this.props.isCheckInvite,
      inviteeErrorCode: this.props.inviteeErrorCode,
      inviteeErrorMessage: this.props.inviteeErrorMessage,
      checkInviteeErrorMessage: this.props.checkInviteeErrorMessage,
      maxSmsSendMessageError: this.props.maxSmsSendMessageError,
      dataNotUpdatedErrorMessage: this.props.dataNotUpdatedErrorMessage,
      editInventDetails: this.props.editInventDetails,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isCheckInvite != this.props.isCheckInvite) {
      this.setState({isCheckInvite: this.props.isCheckInvite});
    }
    if (prevProps.inviteeErrorCode != this.props.inviteeErrorCode) {
      this.setState({inviteeErrorCode: this.props.inviteeErrorCode});
    }
    if (prevProps.inviteeErrorMessage != this.props.inviteeErrorMessage) {
      this.setState({inviteeErrorMessage: this.props.inviteeErrorMessage});
    }
    if (prevProps.checkInviteeErrorMessage != this.props.checkInviteeErrorMessage) {
      this.setState({checkInviteeErrorMessage: this.props.checkInviteeErrorMessage});
    }
    if (prevProps.maxSmsSendMessageError != this.props.maxSmsSendMessageError) {
      this.setState({maxSmsSendMessageError: this.props.maxSmsSendMessageError});
    }
    if (prevProps.dataNotUpdatedErrorMessage != this.props.dataNotUpdatedErrorMessage) {
      this.setState({dataNotUpdatedErrorMessage: this.props.dataNotUpdatedErrorMessage});
    }
    if (prevProps.editInventDetails != this.props.editInventDetails) {
      const emailObj = this.props.editInventDetails ? this.props.editInventDetails.email : null;
      const smsObj = this.props.editInventDetails ? this.props.editInventDetails.phone : null;
      let selectedEmailFromAddress = this.state.selectedEmailFromAddress;
      if (emailObj) {
        selectedEmailFromAddress = this.state.optionEmailFromAddresses.find(email => email.label == emailObj.from);
      }
      this.setState({
        emailSubject: emailObj ? emailObj.subject : getMessage("INVITE_USER_TITLE"),
        emailMessage: emailObj ? emailObj.message : getMessage("INVITE_USER", {userName: this.props.userName}),
        smsMessage: smsObj ? smsObj.message : getMessage("INVITE_USER", {userName: this.props.userName}),
        selectedEmailFromAddress,
      });
    }
  }

  handleEmailToInputChange = (event) => {
    this.setState({
      emailToAddresses: event.target.value,
      emailSubjectError: false,
      emailMessageError: false,
      isCheckInvite: false,
      inviteeErrorCode: "",
      inviteeErrorMessage: "",
      checkInviteeErrorMessage: "",
      dataNotUpdatedErrorMessage:"",
    });
  }

  handleEmailSubjectInputChange = (event) => {
    this.setState({
      emailSubject: event.target.value,
      emailSubjectError: false,
    });
  }

  handleEmailAddressInputChange = (selectedEmailFromAddress) => {
    this.setState({
      selectedEmailFromAddress,
    });
  }

  handleEmailMessageInputChange = (event) => {
    this.setState({
      emailMessage: event.target.value,
      emailMessageError: false,
    });
  }

  handleSmsToInputChange = (event) => {
    this.setState({
      smsToNumber: event.target.value,
      smsMessageError: false,
      isCheckInvite: false,
      inviteeErrorCode: "",
      inviteeErrorMessage: "",
      checkInviteeErrorMessage: "",
      maxSmsSendMessageError: "",
      dataNotUpdatedErrorMessage:"",
    });
  }

  handleSmsMessageInputChange = (event) => {
    let maxLength = this.state.smsMessageMaxLength;
    if(event.target.value.match(/^[\x20-\x7e]*$/)){
      maxLength = SMS_MESSAGE_MAX_LENGTH.EN;
    }else{
      maxLength = SMS_MESSAGE_MAX_LENGTH.JA;
    }
    this.setState({
      smsMessage: event.target.value,
      smsMessageError: false,
      smsMessageMaxLength: maxLength,
    });
  }

  isValidateErrorEmailToAddresses = () => {
    if (!this.state.emailToAddresses) {
      return false;
    }

    const separators = [",", ";"];
    const arrayOfEmails = this.state.emailToAddresses.split(
      new RegExp(separators.join("|"), "g")
    );

    for (let i = 0; i < arrayOfEmails.length; i++) {
      let email = arrayOfEmails[i];
      let isValidEmail = validator.isEmail(email);
      if(!isValidEmail) {
        this.setState({
          inviteeErrorMessage: getMessage("VALID_EMAIL"),
          inviteeErrorCode: "VALID_EMAIL"
        });
        return true;
      }
    }

    return false;
  };

  isValidateErrorSmsToNumber = () => {
    if (!this.state.smsToNumber) {
      return false;
    }

    const separators = [",", ";"];
    const arrayOfPhone = this.state.smsToNumber.split(
      new RegExp(separators.join("|"), "g")
    );

    if ((! this.props.isSMSEnabled) && (arrayOfPhone.length != 0)) {
      this.setState({
        inviteeErrorMessage: getMessage("ERR_MSG_UNABLE_SMS"),
        inviteeErrorCode: "ERR_MSG_UNABLE_SMS",
      });
      return true;
    }

    for (let i = 0; i < arrayOfPhone.length; i++) {
      if (arrayOfPhone[i]) {
        let isValidPhone = validateMobileNumber(arrayOfPhone[i]);
        if(!isValidPhone) {
          this.setState({
            inviteeErrorMessage: getMessage("VALID_PHONE"),
            inviteeErrorCode: "VALID_PHONE",
          });
          return true;
        }
      }
    }

    return false;
  }

  handleScheduleMeeting = () => {
    let emailSubjectError = false;
    let emailMessageError = false;
    let smsMessageError = false;
    if (this.state.emailToAddresses) {
      if (!this.state.emailSubject) {
        emailSubjectError = true;
      }
      if (!this.state.emailMessage) {
        emailMessageError = true;
      }
    }
    if (this.state.smsToNumber) {
      if (!this.state.smsMessage) {
        smsMessageError = true;
      }
    }
    this.setState({
      emailSubjectError,
      emailMessageError,
      smsMessageError,
    });

    if (this.isValidateErrorEmailToAddresses()) {
      return;
    }
    if (this.isValidateErrorSmsToNumber()) {
      return;  
    }

    if ( emailSubjectError || emailMessageError || smsMessageError) {
      return;
    }

    const customize = {
      email: {
        from: this.state.selectedEmailFromAddress.value,
        subject: this.state.emailSubject,
        message: this.state.emailMessage,
      },
      phone: {
        message: this.state.smsMessage,
      }
    };
    this.props.handleScheduleMeeting(this.state.emailToAddresses, this.state.smsToNumber, customize);
  }

  render() {
    return (
      <div className="UserInviteCustomize container-fluid">
        <Row>
          <label className="labelStyle mt-2">
            <img src={icBar} className="mr-2 pb-2"/>
            {getMessage("MAIL_LABEL")}
          </label>
        </Row>
        <Row>
          <label className="labelStyle">{getMessage("TO_LABEL")}</label>
        </Row>
        <Row>
          <Input
            type="text"
            name="text"
            className="inputFormControl"
            required
            placeholder={getMessage("INVITE_INPUT_PLACEHOLDER")}
            onChange={this.handleEmailToInputChange}
            value={this.state.emailToAddresses}
          />
        </Row>
        <Row>
          <label className="labelStyle mt-2">
            {getMessage("SUBJECT_LABEL")}
            { this.state.emailSubjectError &&
              <span className="text-danger font-weight-bold">
                { "  " + getMessage("ERROR_MGS_PLEASE_ENTER")}
              </span>
            }
          </label>
        </Row>
        <Row>
          <Input
            type="text"
            name="text"
            className="inputFormControl"
            required
            placeholder={getMessage("SUBJECT_PLACEHOLDER")}
            onChange={this.handleEmailSubjectInputChange}
            value={this.state.emailSubject}
            maxLength={255}
          />
        </Row>
        <Row>
          <label className="labelStyle mt-2">{getMessage("FROM_LABEL")}</label>
        </Row>
        <Row>
          <Select
            className="emailAddressSelect"
            options={this.state.optionEmailFromAddresses}
            value={this.state.selectedEmailFromAddress}
            onChange={this.handleEmailAddressInputChange}
          />
        </Row>
        <Row>
          <label className="labelStyle mt-2">
            {getMessage("MESSAGE")}
            { this.state.emailMessageError &&
              <span className="text-danger font-weight-bold">
                { "  " + getMessage("ERROR_MGS_PLEASE_ENTER")}
              </span>
            }
          </label>
        </Row>
        <Row>
          <textarea
            className="form-control"
            id="emailTextarea"
            placeholder={getMessage("MESSAGE_PLACEHOLDER")}
            rows="3"
            onChange={this.handleEmailMessageInputChange}
            value={this.state.emailMessage}
            maxLength={this.state.emailMessageMaxLength}
          />
        </Row>
        <Row>
          <div className="w-100 text-right">
            <label className="labelStyle mt-2">
              {getMessage(
                "NUMBER_CHARACTERS_LABEL",
                {
                  currentLength: this.state.emailMessage ? this.state.emailMessage.length : 0,
                  maxLength: this.state.emailMessageMaxLength
                }
              )}
            </label>
          </div>
        </Row>
        { this.props.isSMSEnabled &&
          <div>
            <Row>
              <label className="labelStyle mt-4">
                <img src={icBar} className="mr-2 pb-2"/>
                {getMessage("SMS_LABEL")}
              </label>
            </Row>
            <Row>
              <label className="labelStyle">{getMessage("TO_LABEL")}</label>
            </Row>
            <Row>
              <Input
                type="text"
                name="text"
                className="inputFormControl"
                required
                placeholder={getMessage("INVITE_INPUT_PLACEHOLDER")}
                onChange={this.handleSmsToInputChange}
                value={this.state.smsToNumber}
                maxLength={this.state.smsMessageMaxLength}
              />
            </Row>
            <Row>
              <label className="labelStyle mt-2">
                {getMessage("MESSAGE")}
                { this.state.smsMessageError &&
                  <span className="text-danger font-weight-bold">
                    { "  " + getMessage("ERROR_MGS_PLEASE_ENTER")}
                  </span>
                }
              </label>
            </Row>
            <Row>
              <textarea
                className="form-control"
                id="emailTextarea"
                placeholder={getMessage("MESSAGE_PLACEHOLDER")}
                rows="3"
                onChange={this.handleSmsMessageInputChange}
                value={this.state.smsMessage}
                maxLength={this.state.smsMessageMaxLength}
              />
            </Row>
            <Row>
              <div className="w-100 text-right">
                <label className="labelStyle mt-2">
                  {getMessage(
                    "NUMBER_CHARACTERS_LABEL",
                    {
                      currentLength: this.state.smsMessage ? this.state.smsMessage.length : 0,
                      maxLength: this.state.smsMessageMaxLength
                    }
                  )}
                </label>
              </div>
            </Row>
          </div>
        }
        {(!this.state.isCheckInvite) ?
          <Row className="d-flex justify-content-center errors my-0 py-2 autoHeight">
            {this.state.inviteeErrorCode === "PROPS"
              ? this.state.inviteeErrorMessage
              : getMessage(this.state.inviteeErrorCode)}
          </Row> :
          <>
            <Col className="errors text-center error-message autoHeight">
              {this.state.checkInviteeErrorMessage}
            </Col>
            <Col className="errors text-center error-message autoHeight">
              {this.props.showCheckInvite()}
            </Col>
          </>
        }
        <div className="errors autoHeight">{getMessage(this.state.maxSmsSendMessageError)}</div>
        <div className="d-flex justify-content-center">
          <Col sm={6} xl={6}>
            <div className="errors autoHeight">{getMessage(this.state.dataNotUpdatedErrorMessage)}</div>
            <button
              id="proceedBtn"
              className="startBtn btn shadow-none rounded-pill w-100 whiteOnClick py-2"
              onClick={this.handleScheduleMeeting}
            >
              {this.props.isSchedule
                ? getMessage("SCHEDULE_MEETING_BUTTON")
                : getMessage("SEND_SMS_OR_EMAIL")
              }
            </button>
          </Col>
        </div>
      </div>
    )
  }
}

export default modalScrollBar(UserInviteCustomize);
